import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { PushCreateTemplate } from 'components/Templates'

const Push: FC = () => {
  return (
    <Layout headline={'運営からのお知らせ'} title={'プッシュ通知設定'}>
      <PushCreateTemplate />
    </Layout>
  )
}

export default Push
